import { gql } from '@apollo/client';
import TENANT_ORDER_OPERATOR from 'api/fragments/TENANT_ORDER_OPERATOR';
const GET_CURRENT_TENANT_ORDER_OPERATORS = gql `
  ${TENANT_ORDER_OPERATOR}
  query GetCurrentTenantOrderOperators($first: Int, $after: String, $name: String) {
    me {
      id
      currentTenant {
        id
        orderOperators(first: $first, after: $after, name: $name) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...TenantOrderOperatorFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_ORDER_OPERATORS;
